import React, { useMemo } from 'react';
import { useHtmlClassService } from '../../_core/MetronicLayout';

export function Footer() {
	const today = new Date().getFullYear();
	const uiService = useHtmlClassService();

	const layoutProps = useMemo(() => {
		return {
			footerClasses: uiService.getClasses('footer', true),
			footerContainerClasses: uiService.getClasses('footer_container', true),
		};
	}, [uiService]);

	return (
		<div
			className={`footer bg-white py-2 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
			id="kt_footer"
		>
			<div
				className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
			>
				<div className="text-dark order-2 order-md-1">
					<p className="m-auto">
						&copy; {process.env.REACT_APP_NAME}{' '}
						<span className="text-muted font-weight-bold mr-2">
							SAOC {today.toString()}
						</span>
						<span className="font-size-sm ">
							En caso de dudas o comentarios, estamos a sus órdenes a través
							del correo electrónico: seguimientocolegiados@infonavit.org.mx
						</span>
					</p>
				</div>
			</div>
		</div>
	);
}
